export default __webpack_public_path__ + "static/media/786.3cedcccc.gif";